const careers = () => {
    $('.career-list').on('click', '.career-item', function(){
        $(".careers .detail").fadeIn();
        $("html").addClass("overflow-hidden");
    })

    $(".careers .detail .close-modal").on("click", function(){
        $("html").removeClass("overflow-hidden");
        $(".careers .detail").fadeOut();
    })

    $(".careers .detail .link-close-modal").on("click", function(){
        $("html").removeClass("overflow-hidden");
        $(".careers .detail").fadeOut();
        window.location.reload();
    })
}

module.exports = careers
